'use client';

import React from 'react';
import DataTable from 'react-data-table-component';

const ReusableTable = ({ columns, data, title }) => {
  return (
    <div className="mt-4">
      <h3>{title}</h3>
      <DataTable
        columns={columns}
        data={data}
        pagination
        highlightOnHover
        responsive
      />
    </div>
  );
};

export default ReusableTable;
